import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_214_41304)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.6665 9.99997L9.70169 14.0176C9.81101 14.0722 9.86567 14.0996 9.923 14.1103C9.97378 14.1198 10.0259 14.1198 10.0767 14.1103C10.134 14.0996 10.1887 14.0722 10.298 14.0176L18.3332 9.99997M1.6665 14.1666L9.70169 18.1842C9.81101 18.2389 9.86567 18.2662 9.923 18.277C9.97378 18.2865 10.0259 18.2865 10.0767 18.277C10.134 18.2662 10.1887 18.2389 10.298 18.1842L18.3332 14.1666M1.6665 5.83331L9.70169 1.81571C9.81101 1.76105 9.86567 1.73372 9.923 1.72297C9.97378 1.71344 10.0259 1.71344 10.0767 1.72297C10.134 1.73372 10.1887 1.76105 10.298 1.81571L18.3332 5.83331L10.298 9.8509C10.1887 9.90556 10.134 9.93289 10.0767 9.94365C10.0259 9.95317 9.97378 9.95317 9.923 9.94365C9.86567 9.93289 9.81101 9.90556 9.70169 9.8509L1.6665 5.83331Z",
    stroke: "#667085",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_214_41304" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20",
      height: "20",
      fill: "white"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Layers',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
}

})